/** 与用户端 lib/api-error.ts 同语义：把 ApiError 翻成可展示的本地话文案。 */
import { isApiError } from "@profitlens/api-client";

type Translator = (key: string) => string;

export function translateError(error: unknown, t: Translator): string {
  if (isApiError(error)) {
    const key = `errors.${error.code}`;
    const translated = t(key);
    if (translated !== key) return translated;
    if (error.message) return error.message;
  }
  if (error instanceof Error && error.message) return error.message;
  return t("errors.unknown");
}
